export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.7-1208.54",
  commitId: "78e28343a9b443178c3545ebf50bfc4aa875ed83",
  commitTime: "2026-08-07T12:08:54.000Z",
});
